/**
 * jQuery Unveil
 * A very lightweight jQuery plugin to lazy load images
 * http://luis-almeida.github.com/unveil
 *
 * Extended by Estudioliver@2015
 *
 * Licensed under the MIT license.
 * Copyright 2013 Luís Almeida
 * https://github.com/luis-almeida
 */

;
(function ($) {

    $.fn.unveil = function (threshold, callback) {

        var $w     = $(window),
            me     = this,
            th     = threshold || 0,
            retina = window.devicePixelRatio > 1,
            attrib = retina ? "data-src-retina" : "data-src",
            images = this,
            loaded;

        this.one("unveil", function ()
        {
            var im = this;
            var source = this.getAttribute(attrib);
            source     = source || this.getAttribute("data-src");

            if (source)
            {

                var imatge = new Image();
                imatge.onload = function (evt) {

                    console.log("onload img unveil");

                    if( im.nodeName.match(/img/i))
                    {

                        /*
                        // FADER
                        $(im).fadeOut('fast',function(){
                            $(this).attr('src',source).fadeIn('slow');
                        });
                        */

                        $(im).attr('src',source).fadeIn('slow');

                        $(im).css('background','inherit!important')
                            .removeClass('preload-size loader blur');


                    }else{

                        var focus = $(im).data('focus') || "50% 50%";


                        $(im).css({
                                'background-image': 'url(' +source + ')',
                                'background-position': focus
                            }).removeClass('preload-size loader blur')

                    }

                };

                if (typeof callback === "function") callback.apply(im,[imatge]);

                setTimeout(function () {

                    if (imatge.complete || imatge.complete === void 0) {
                        console.log("complete img unveil");
                        imatge.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
                        imatge.src = source;

                    } else {

                        imatge.src = source;

                    };

                    $(im).trigger('init.unveil');

                }, 50);


            }

        });

        function unveil() {
            var inview = images.filter(function () {
                var $e = $(this);
                if ($e.is(":hidden")) return;

                var wt = $w.scrollTop(),
                    wb = wt + $w.height(),
                    et = $e.offset().top,
                    eb = et + $e.height();

                return eb >= wt - th && et <= wb + th;
            });

            loaded = inview.trigger("unveil");
            images = images.not(loaded);
        }

        $w.on("scroll.unveil resize.unveil lookup.unveil", unveil);

        unveil();

        return this;

    };

})(window.jQuery || window.Zepto);